import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { BlobService } from 'src/app/core/services/blob.service';
import {
	BasePopupData,
	BasePopupComponent
} from '../popup/base-popup/base-popup.component';
import { AlertService } from 'src/app/core/services/alert.service';
import { PopupService } from '../../services';

@Component({
	selector: 'app-import-excel',
	templateUrl: './import-excel.component.html',
	styleUrls: ['./import-excel.component.scss']
})
export class ImportExcelComponent {
	fileName = '';
	formData: any;
	validateError: boolean;

	@ViewChild('fileInput') fileInput: ElementRef;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private blobService: BlobService,
		private dialog: MatDialog,
		private alertService: AlertService,
		private popupService: PopupService
	) {}

	checkFile(event: any) {
		if (event.target) {
			this.fileName = event.target.files[0].name;
			const file = event.target.files[0] as File;
			this.formData = new FormData();
			this.formData.append('file', file);
			const requestDto = {};
			this.formData.append('requestDto', JSON.stringify(requestDto));
		}
		this.revisarFile(this.fileName);
	}

	revisarFile(type: any) {
		const fileExtension = type.split('.').pop()?.toLowerCase();
		if (fileExtension !== 'xlsx') {
			this.validateError = true;
		} else {
			this.validateError = false;
		}
	}

	uploadFile() {
		const confirmationData: BasePopupData = {
			subtitle: `¿Desea procesar el archivo para registrar ${this.data.type}?`,
			buttonCancelText: 'Cancelar',
			buttonConfirmText: 'Confirmar'
		};
		this.dialog
			.open(BasePopupComponent, {
				width: this.popupService.messagePopupWidth,
				data: confirmationData
			})
			.afterClosed()
			.subscribe((result: any) => {
				if (result) {
					this.blobService.baseUrl = this.data.api;
					this.blobService.url = this.data.route;
					this.blobService.fileUpload(this.formData).subscribe(
						result => {
							this.showInfo(result?.numero);
						},
						() => {
							this.showUploadError();
							this.fileInput.nativeElement.value = null;
							this.formData = new FormData();
							this.fileName = '';
						}
					);
				}
			});
	}

	showInfo(nroProceso: number) {
		const numeroProcesoText =
			nroProceso != null && nroProceso !== 0
				? `Número de proceso: ${nroProceso}`
				: 'No se obtuvo el número de proceso; consulte Ver Resultados.';
		const confirmationData: BasePopupData = {
			subtitle: `El proceso se ejecutará en forma asincrónica.\nPodrá consultar su estado y detalle más tarde.\n${numeroProcesoText}`,
			buttonCancelText: 'Aceptar'
		};
		const dialogRef = this.dialog.open(BasePopupComponent, {
			width: '25vw',
			data: confirmationData
		});
		dialogRef.afterClosed().subscribe(() => {
			this.close();
		});
	}

	private showUploadError() {
		const details =
			this.alertService.datosError?.details || 'Error al procesar el archivo';
		const message = this.fileName ? `${this.fileName}: ${details}` : details;
		this.dialog.open(BasePopupComponent, {
			width: this.popupService.messagePopupWidth,
			data: {
				subtitle: message,
				buttonCancelText: 'Aceptar'
			} as BasePopupData
		});
	}

	close() {
		this.dialog.closeAll();
	}
}
